simply.addToCart = function () {
  let checkout = false;
  let shopifyCheckout = false;
  let hmDigital4 = false;
  let stonetasticPage = false;
  if($('.whatever-4').length > 0){
    hmDigital4 = true;
  }
  let hmDigital5 = false;
  if($('.whatever-5').length > 0){
    hmDigital5 = true;
  }
  let hmDigital2 = false;
  if($('.whatever-2').length > 0){
    hmDigital2 = true;
  }
  let knifeHmDigital4 = false;
  if($('.knife-set-hm-digital-4').length > 0){
    knifeHmDigital4 = true;
  }
  if (window.location.href.split('&')[1] == 'checkout') {
    checkout = true;
  }
  if($('#cooking-acc-page-third-version').length > 0){
    shopifyCheckout = true;
  }
  if($('.stonetastic-hm-digital-3').length > 0){
    stonetasticPage = true;
  };
  let combo_id = $('.choose-configure #combo-product').val();
  $('.process-to-checkoutbtn .process-to-checkout-btn').click(function () {
    let bulk_order = [];
    let show_combo_product = false;
    let cookingPage = $('.choose-configure').hasClass('cooking-acc-configure');
    let hmDigital_5 = $('body').hasClass('hm-digital-5');
    let freeProductExist = false;
    var usernames = $('.chekboxwrap .checkmark').map(function () {
      let item = this;
      if(!$(item).hasClass('cooking-acc-radio')){
        if ($(item).hasClass('checked')) {
          if ($(item).hasClass('second-product') && combo_id.length > 1) {
            show_combo_product = true;
          } else {
            let p_id = $(item).attr('variant-id');
            if(hmDigital4 && p_id == 39609619448005 ){
              freeProductExist = true;
              bulk_order.push({ quantity: 1, id: p_id,properties: {
                '_hm-digital': true,
                '_free-cookbook':true
              }})
            }else if(stonetasticPage && p_id == 36738537128103){
              freeProductExist = true;
              bulk_order.push({ quantity: 1, id: p_id,properties: {
                '_hm-digital': true,
                '_free-academy':true
              }});
            }else if(hmDigital2 && p_id == 39609619448005){
              freeProductExist = true;
              bulk_order.push({ quantity: 1, id: p_id,properties: {
                '_hm-digital': true,
                '_free-cookbook':true
              }});
            }else{
              bulk_order.push({ quantity: 1, id: p_id,properties: {
                '_hm-digital': true
              }});
            }
          }
        }
      }
    });
    
    let p_id = $('.radio-wrap .checkmark').attr('variant-id');
    if(cookingPage || hmDigital_5){
      p_id = $('input[type="radio"]:checked').siblings('span').attr('variant-id');
    }
    if(hmDigital5){
      p_id = $('.radio-wrap .checkmark.checked').attr('variant-id');
    }
    if (show_combo_product) {
      bulk_order.push({ quantity: 1, id: combo_id,properties: {
        '_hm-digital': true
      }});
    } else {
      if(hmDigital4 && p_id == 39349657043141 && freeProductExist){
        bulk_order.push({ quantity: 1, id: p_id,properties: {
          '_hm-digital': true,
          '_free-cookbook':true
        }});
      }else if(stonetasticPage && p_id == 32633661358212 && freeProductExist){
        bulk_order.push({ quantity: 1, id: p_id,properties: {
          '_hm-digital': true,
          '_free-academy':true
        }});
      }else if(hmDigital2 && p_id == 39349657043141 && freeProductExist){
        bulk_order.push({ quantity: 1, id: p_id,properties: {
          '_hm-digital': true,
          '_free-cookbook':true
        }});
      }else{
        bulk_order.push({ quantity: 1, id: p_id,properties: {
          '_hm-digital': true
        }});
      }
    }
    if(shopifyCheckout && bulk_order.length > 1){
      checkout = true;
    }
    $('.loading-gif').show();
    $('.process-to-checkoutbtn .process-to-checkout-btn').prop('disabled', true);
    if($('.process-to-checkoutbtn .process-to-checkout-btn').hasClass('direct-checkout')){
      checkout = true;
    }
    addItems(bulk_order, function () {
      bulk_order = [];
      if(shopifyCheckout || checkout){
        window.location = '/checkout';
      }else {
        window.location = '/cart';
      }
    });
  });
};
var addItems = function (data, callback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: { items: data },
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback();
      }
    },
    error: function (err) {
      console.log(err);
    }
  };
  jQuery.ajax(params);
};
simply.slider = function () {
  $('.productimgSlider').slick({
    infinite: true,
    dots: true,
    nav: true,
    adaptiveHeight: true,
    fade: true,
  	cssEase: 'linear'
  });
  $('.reviewSlider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.whatever-3-slider').slick({
    dots: false,
    nav: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false
  });
  $('.whatever-pan-3-top .media-section-slider-inner').slick({
    dots: false,
    nav: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
    ]
  });
  $('.review_sliderr').slick({
    dots: false,
    nav: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  });
  $('.hm-digital5-view .radio-wrap.product-one-wrap').click(function(){
    $('.product-one-wrap.radio-wrap .checkmark').removeClass('checked');
    $('.checkmark',this).addClass('checked');
  })
  $('.lft-summary > a').click(function () {
    $(this).toggleClass('show');
    $('.checkout-cart-display').toggle();
    if ($(this).hasClass('show')) {
      $(this).html('Hide Order summary');
    } else {
      $(this).html('Show Order summary');
    }
  });
  $('.chekboxwrap .checkmark').click(function () {
    $(this).toggleClass('checked');
  });
  $('.scroll').click(function () {
    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top,
      },
      1500
    );
    return false;
  });
};

simply.clickeventsFaqs = function () {
  $('.faq-section .que').click(function(event) {
    /* Act on the event */
    var parent = $(this).closest('.qna');
    $('.ans',parent).stop().slideToggle();
    $(parent).stop().toggleClass('active');
  });

  // whatever-pan-items
  $('.whatever-pan-items .product-one-wrap').click(function(event) {
    $('.whatever-pan-items .product-one-wrap').removeClass('active-item');
    $(this).addClass('active-item');
  });
}

simply.dateTimeCountdown = function (){
  let parent = $('.date-time-countdown-wrap');
  let startDate = new Date(simply.currentDate);
  let dayDigit = simply.currentDayDigit;
  let addDay = simply.digital_next_day;
  let nonWeekend = true;
  if(dayDigit == 6 || dayDigit == 7 ){
    nonWeekend = false;
    startDate.setDate(startDate.getDate() + ( 8 - dayDigit ));
  }
  if(!nonWeekend || simply.currentHour >= simply.digital_next_hour){
    addDay = simply.digital_next_day + 1;
  }
  let endDate = "",  count = 0;
  while(count < addDay){
    endDate = new Date(startDate.setDate(startDate.getDate() + 1));
    if(endDate.getDay() != 0 && endDate.getDay() != 6){
      count++;
    }
  }
  let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let monthName = months[endDate.getMonth()];
  let dayName = days[endDate.getDay()];
  let date = endDate.getDate();
  if(date == 1){
    date += 'st'; 
  }else if(date == 2){
    date += 'nd'; 
  }else if(date == 3){
    date += 'rd'; 
  }else{
    date += 'th'; 
  }
  let deliverDate = `${dayName}, ${monthName} ${date}`;
  $('.deliver-date',parent).text(deliverDate);
}
simply.timeCountDown = function (){
  let difference = simply.end_date - simply.start_date;
  function timer() {
    let days = Math.floor(difference / 24 / 60 / 60);
    let hoursLeft = Math.floor(difference - (days * 86400));
    let hours = Math.floor(hoursLeft / 3600);
    let minutesLeft = Math.floor((hoursLeft) - (hours * 3600));
    let minutes = Math.floor(minutesLeft / 60);
    let remainingSeconds = difference % 60;
    let countTime = '';
    if(hours > 0){
      countTime = hours + " hrs " + minutes + " mins " + remainingSeconds + " seconds";
    }else{
      countTime = minutes + " mins " + remainingSeconds + " seconds";
    }
    $('.deliver-time-wrap').text(countTime);
    if (difference != 0) {
      difference--;
      setTimeout(timer, 1000);
    }
  }
  timer();
}
$(document).ready(function () {
  if($('.date-time-countdown-wrap').length > 0){
    simply.dateTimeCountdown();
    simply.timeCountDown();
  }
  simply.slider();
  simply.addToCart();
  simply.clickeventsFaqs();
  var product_title_parent =
    '.choose-accessories .productsection .product-title';
  var product_title_child = '.choose-accessories .productsection .product-title';
  simply.miniHeight(product_title_parent, product_title_child);
  setTimeout(() => {
    $('.productimgSlider').slick('refresh');
  }, 5000);
});


$(window).resize(function () { 
  $('.productimgSlider').slick('refresh');
});
